'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { THEME_TESTER_ORIGINS } from '@hub/common/src/constants';

// send the current location to the parent window every time the pathname changes
// this used for the iframe on the WebPublishingTheme page, so that we can keep track of the iframe url
export default function SendLocationToParent() {
  const pathname = usePathname();

  useEffect(() => {
    // the theme tester is the only page that listens for this, so it is the only one told. Without
    // a target origin every embedder of the HUB would receive the message, and there is nobody
    // meaningful to tell when the tester is not configured. A target origin only delivers to a
    // parent that matches it, so walking the allowed testers reaches whichever one is framing us
    // and is silently dropped for the rest
    THEME_TESTER_ORIGINS.forEach((origin) => {
      window.parent.postMessage(
        {
          type: 'LOCATION',
          location: window.location.href
        },
        origin
      );
    });
  }, [pathname]);

  return null;
}
